import { createFileRoute } from '@tanstack/react-router'

import { SettingsLayout } from '@/pages/Settings/SettingsLayout'

export const Route = createFileRoute('/_app/settings/_userManagement')({
  component: SettingsLayout,
})
